export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20amber%20and%20deep%20crimson%20gradients%2C%20soft%20film%20grain%20texture%2C%20subtle%20lens%20flares%2C%20dark%20theater%20atmosphere%2C%20elegant%20curtain%20drapes%20on%20edges%2C%20dramatic%20lighting%2C%20movie%20screen%20glow%2C%20no%20text%2C%20no%20people%2C%20artistic%20style&width=1800&height=900&seq=hero-bg-cinema&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-white">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 backdrop-blur-sm mb-5">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-accent-300 text-xs font-medium tracking-wider">每日更新 · 高清免费 · 免VIP</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-4">
              成全影视 · 高清免费影视平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              你的专属免费追剧天堂
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-2xl mb-8">
              成全影视汇聚海量高清免费影视资源，涵盖热门电影、电视剧、综艺、动漫等全品类内容。每日持续更新最新剧集，无需注册、无需VIP，打开即看。无论是最新上线的热门大片，还是经典怀旧的老剧，在这里都能找到，流畅追剧体验一触即达。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-400 whitespace-nowrap">20000+</span>
                <span className="text-xs md:text-sm text-white/55">部影视资源</span>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-400 whitespace-nowrap">每日更新</span>
                <span className="text-xs md:text-sm text-white/55">最新剧集</span>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-400 whitespace-nowrap">1080P</span>
                <span className="text-xs md:text-sm text-white/55">高清画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#media');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#cards');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-lg bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200 border border-white/20"
              >
                <i className="ri-thumb-up-line text-lg"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20film%20poster%20style%20composition%2C%20dramatic%20warm%20lighting%20with%20golden%20and%20crimson%20highlights%2C%20film%20strip%20elements%2C%20movie%20clapperboard%2C%20vintage%20cinema%20texture%2C%20elegant%20art%20deco%20patterns%2C%20theatrical%20spotlight%20effect%2C%20luxurious%20velvet%20curtain%20draping%2C%20no%20text%2C%20artistic%20style%2C%20rich%20contrast&width=960&height=1200&seq=hero-visual-movie&orientation=portrait"
                alt="成全影视 - 高清免费影视平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-white text-2xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-heading font-semibold text-sm">热门精选</p>
                    <p className="text-white/60 text-xs">今日更新 36 部</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}